import { render, staticRenderFns } from "./LongTailList.vue?vue&type=template&id=80d35a9c&scoped=true&"
import script from "./LongTailList.vue?vue&type=script&lang=js&"
export * from "./LongTailList.vue?vue&type=script&lang=js&"
import style0 from "./LongTailList.vue?vue&type=style&index=0&id=80d35a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d35a9c",
  null
  
)

export default component.exports